// 함수 모음
import util from '@/utils/utils'
import requestApi from '@/utils/requestApi'
import store from '@/store'
import eventBus from '@/utils/eventBus'
import $ from 'jquery'

export default {
  /**
   * @TODO 함수설명 필요
   **/
  toStr: (str) => {
    return str+"";
  },
  /**
   * @TODO 함수설명 필요
   **/
  nvl : (str, restr) => {
    if(str==="" || str === null || typeof(str) === "undefined" || str ==="undefined" || str ==="null"){
      if(restr===""){
        return "";
      }else{
        return restr;
      }
    }else{
      return str;
    }
  },
  isNull : (str) => {
    if( str === "" || str === null || str === undefined || typeof(str) === "undefined" || str ==="undefined" || str ==="null"){
      return true
    }else{
      return false
    }
  },
  /**
   * @TODO 함수설명 필요
   * 로깅처리 하는 글로벌 Util
   * LOGGING =="YES" 일때만 처리함
   **/
  log : (msg, level) => {
    if ( window.console && window.console.log ) {
      if(util.isNull(level)) level = "DEBUG";
      let loggingMode = process.env.VUE_APP_LOGGING;
      if(loggingMode === "DEBUG"){
        if(level === "DEBUG" || level === "INFO" || level === "ERROR" || level === "FATAL"){
          console.log(level+"|", msg);
        }
      }
      if(loggingMode === "INFO"){
        if(level === "INFO" || level === "ERROR" || level === "FATAL") {
          console.log(level+"|", msg);
        }
      }
      if(loggingMode === "ERROR"){
        if(level === "ERROR" || level === "FATAL") {
          console.log(level+"|", msg);
        }
      }
      if(loggingMode === "FATAL") {
        if(level === "FATAL") {
          console.log(level+"|", msg);
        }
      }
    }
  },
  /**
   * @TODO 좌우  Trim
   **/
  trim : (data) => {
    return data.replace(/^\s+|\s+$/g, '');
  },
  /**
   * @TODO 왼쪽으로  Trim
   **/
  ltrim : (data) => {
    return data.replace(/^\s+/, '');
  },
  /**
   * @TODO 오른쪽으로 trim
   **/
  rtrim : (data) => {
    return data.replace(/\s+$/, '');
  },
  /**
   * @TODO 소수점 자리숫를 파싱한다.
   **/
  toRoundFix : (data, digit) => {
    return parseFloat(data).toFixed(digit);
  },
  fillZero : (number,width) => {
    width -= number.toString().length;
    if ( width > 0 ){
      return new Array( width + (/\./.test( number ) ? 2 : 1) ).join( '0' ) + number;
    }
    return number + ""; // always return a strin
  },
  hex2Float : (number,underDigit) => {
    let sNum = "";
    let num = parseInt(number,16);
    sNum += parseFloat(num/100).toFixed(underDigit);
    return sNum;
  },
  decimalToHex : (d, padding) => {
    let hex = Number(d).toString(16);
    padding = typeof (padding) === "undefined" || padding === null ? padding = 2 : padding;

    while (hex.length < padding) {
      hex = "0" + hex;
    }
    return hex.toUpperCase();
  },
  left : (str,n) => {
    if (n <= 0){
      return "";
    }else if (n > String(str).length){
      return str;
    }else{
      return String(str).substring(0,n);
    }
  },
  right : (str,n) => {
    if (n <= 0){
      return "";
    }else if (n > String(str).length) {
      return str;
    }else{
      let iLen = String(str).length;
      return String(str).substring(iLen, iLen - n);
    }
  },
  convert12Hour : (hour) => {
    return ""+util.fillZero((parseInt(hour,10) + 24) % 12 || 12,2);
  },
  getStrLength : (str) => {
    let strLength = 0;
    let i

    for (i = 0; i < str.length; i++) {
      let code = str.charCodeAt(i)
      let ch = str.substr(i,1).toUpperCase()

      code = parseInt(code);

      if ((ch < "0" || ch > "9") && (ch < "A" || ch > "Z") && ((code > 255) || (code < 0)))
        strLength = strLength + 2;
      else
        strLength = strLength + 1;
    }

    return strLength;
  },
  str2Hex : (instr) => {
      let str = ""+instr;
      let hex = '';
      for(let i = 0; i<str.length;i++){
        hex += '' + str.charCodeAt(i).toString(16);
      }
      return hex;
  },
  getTextCutByte : (obj, len) => {
    let str = $(obj).val();
    let str_len = str.length;
    let bytes = 0;
    let result = true;

    for(let i=0; i<str.length; i++){
      let ch = str.charAt(i);
      if(escape(ch).length > 4){
        bytes += 2;
      }else if(ch === '\n'){
        if(str.charAt(i-1) != '\r'){
          bytes += 1;
        }
      }else if(ch === '<' || ch === '>'){
        bytes += 4;
      }else{
        bytes += 1;
      }

      if(bytes > len){
        str_len--;
        $(obj).val(str.substring(0, str_len));
      }
    }

    if(bytes > len){
      result = false;
    }

    return result;
  },
  getOS : () => {
    let ua = String( navigator.userAgent ).toLowerCase();
    if(/iphone|ipad/.test(ua)){
      return "ios";
    }else if(/android/.test(ua)){
      return "android";
    }else{
      return "android";
    }
  },
  setComma: (num) => {
    num = String(num);
    return num.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
  },
  onlyNum : (obj) => {
    $(obj).on("input keypress",function(){
      if(event.keyCode < 48 || event.keyCode > 57){
        return false;
      }
    });

    $(obj).on("input keydown",function(){
      if (!(event.keyCode >=37 && event.keyCode<=40)) {
        let inputVal = $(this).val();
        $(this).val(inputVal.replace(/[^a-z0-9]/gi,''));
      }
    });
  },
  get24To12 :function(hour){
    var _result = 0;
    var _hour = parseInt(hour,10);
    if(_hour === 0){
      _result = 12;
    }else if(_hour > 12){
      _result = _hour - 12;
    }else{
      _result = _hour;
    }
    return _result;
  },
  /**
   * @param2 : 0: 오전 /  1: 오후
   */
  get12To24 :function(hour,ampm){
    let _result = 0;
    let _hour = parseInt(hour,10);

    if(ampm === 0 ){
      if(_hour === 12){
        _result = 0;
      }else{
        _result = _hour;
      }

    }else if(ampm === 1){
      if(_hour != 12){
        _result = _hour + 12;
      }else{
        _result = 12;
      }
    }else{
      return _hour;
    }
    return _result;
  },
  getPhoneNumberHypen : function(val){
    if(!util.isNull(val) && val.length >= 9){
      let num = val.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]+)([0-9]{4})/,"$1-$2-$3");
      return num;
    }else{
      return val;
    }
  },
  replaceAll: (str, searchStr, replaceStr) => {
    if(util.nvl(str, "") === ""){
      return "";
    }
    return str.split(searchStr).join(replaceStr);
  },
  ip2int(ip) {
    return ip.split('.').reduce((ipInt, octet) => {
      return (ipInt<<8) + parseInt(octet, 10)
    }, 0) >>> 0;
  },
  int2ip (ipInt) {
    return ( (ipInt>>>24) +'.' + (ipInt>>16 & 255) +'.' + (ipInt>>8 & 255) +'.' + (ipInt & 255) );
  },
  lpad(str, padLen, padStr) {
    if (padStr.length > padLen) {
      return str
    }
    str += "";
    padStr += ""
    while (str.length < padLen)
      str = padStr + str;
    str = str.length >= padLen ? str.substring(0, padLen) : str;
    return str
  },
  // url에서 쿼리스트링을 추출하여 json 오브젝트로 만들어 준다.
  qryStrToJson(url){
    if(url.indexOf('?') > -1){
      url = decodeURIComponent(url)
      let qryStr = url.split('?')[1]

      let keyAndVal = qryStr.split('&')
      let search = {}
      for (let i = 0; i < keyAndVal.length; i++) {
        let key = keyAndVal[i].split('=')[0]
        let val = keyAndVal[i].split('=')[1]
        search[key] = val
      }
      return search
    }else{
      return null
    }
  },
  // json 오브젝트를 쿼리 스트링으로 만들어 준다.
  jsonToQryStr(json){
    let keys = Object.keys(json)

    let qryStr = '?'
    for (let i = 0; i < keys.length; i++) {
      if(i != 0){
        qryStr += '&' + keys[i] + '=' + (json[keys[i]] ? json[keys[i]] : '')
      }else{
        qryStr += keys[i] + '=' + (json[keys[i]] ? json[keys[i]] : '')
      }
    }
    return qryStr
  },

  /**
   * 사용자 그룹 목록
   *
   * @param {*} options
   */
  getUserGroupList(options) {
    return new Promise((resolve, reject) => {
      requestApi({
        url: '/config/codes/groups',
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            let list = []
            if (options.all) {
              list.push({ text: 'All', value: '' })
            }
            res.data.list.forEach((item) => {
              let obj = {
                value: item.seq,
                text: item.group_name
              }
              list.push(obj)
            })
            resolve(list)
          } else {
            if (res.res_code === '401012') {
              util.setTokenRefresh().then(() => {
                util.getUserGroupList(options)
              })
            } else {
              reject(res)
            }
          }
        }
      })
    })
  },

  /**
   * 코드 목록 조회
   *
   * @param {*} upperCode
   */
  fnGetCodeList(options) {
    return new Promise((resolve, reject) => {
      requestApi({
        url: '/config/codes/upper/'+ options.upper_code,
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            let listEn = [],
            listAr = []

            if (options.all) {
              listEn.push({ text: 'All', value: '' })
              listAr.push({ text: 'جميع', value: '' })
            }

            res.data.list.forEach((item) => {
              let objAr = {
                value: item.code,
                text: item.name_ar
              }
              listAr.push(objAr)

              let objEn = {
                value: item.code,
                text: item.name_en
              }
              listEn.push(objEn)
            })

            if (Array.isArray(options.remove)) {
              options.remove.forEach(item => {
                let listIndex = listEn.findIndex(listItem => {
                  return listItem.value === item.code
                })

                if (listIndex > -1) {
                  listEn.splice(listIndex, 1)
                  listAr.splice(listIndex, 1)
                }
              })
            }
            let code = {
              en: listEn,
              ar: listAr
            }
            resolve(code)
          } else {
            if (res.res_code === '401012') {
              util.setTokenRefresh().then(() => {
                util.fnGetCodeList(options)
              })
            } else {
              reject(res)
            }
          }
        }
      })
    })
  },

  fnGetCountryList(lang) {
    return new Promise((resolve, reject) => {
      requestApi({
        url: '/config/codes/country/'+ ((lang) ? lang : 'en'),
        method: 'GET',
        callback: (res) => {
          if (res.res_code === '200') {
            let list = []

            res.data.list.forEach((item) => {
              let obj = {
                value: item.code,
                text: (lang) ? item['name_'+ lang] : item.name_en +'/'+ item.name_ar
              }
              list.push(obj)
            })
            resolve(list)
          } else {
            if (res.res_code === '401012') {
              util.setTokenRefresh().then(() => {
                util.fnGetCountryList(lang)
              })
            } else {
              reject(res)
            }
          }
        }
      })
    })
  },

  setTokenRefresh() {
    return new Promise((resolve) => {
      requestApi({
        url: '/autho/token',
        method: 'POST',
        data: {
          'access_token': store.state.token.access_token,
          'refresh_token': store.state.token.refresh_token
        },
        callback: (res) => {
          if (res.res_code === '200') {
            store.dispatch('SetAuthHeader', res.data.access_token)
            store.dispatch('SetAccessToken', res.data.access_token)

            resolve()
          } else {
            eventBus.$emit('SHOW_ERROR_SNACKBAR', res)
          }
        }
      })
    })
  },

  getFileExtLen(file, extList, msg) {
    let fileExt = file.name.split('.').pop().toLowerCase()
    let exts = []
    extList.forEach(item => {
      exts.push(item.name_en.toLowerCase())
    })

    let extLen = $.inArray(fileExt, exts)

    if (extLen === -1) {
      let option = {
        text: msg
      }
      eventBus.$emit('SHOW_SNACKBAR', option)
    }

     return extLen
  },

  getExtIcon(file_ext) {
    if(file_ext === 'doc' || file_ext === 'docx'){
      return 'mdi-file-word'
    }else if(file_ext === 'xlsx' || file_ext === 'xls'){
      return 'mdi-file-excel'
    }else if(file_ext === 'ppt' || file_ext === 'pptx'){
      return 'mdi-file-ppt'
    }else if(file_ext === 'pdf'){
      return 'mdi-file-pdf'
    }else if(file_ext === 'png' || file_ext === 'bmp' || file_ext === 'rle' || file_ext === 'dib' ||file_ext === 'gif' || file_ext === 'tif' || file_ext === 'tiff' || file_ext === 'jpg' ){
      return 'mdi-file-image'
    }else{
      return 'mdi-paperclip'
    }
  },

}

export const ckeditorConfig = {
  toolbar: [
    [
      'Cut', 'Copy', 'Paste', 'PasteText', 'PasteFromWord', '-',
      'Undo', 'Redo', '-',
      'Bold', 'Italic', 'Underline', 'Strike', 'Subscript', 'Superscript', '-',
      'NumberedList', 'BulletedList', '-', 'Outdent', 'Indent', '-', 'JustifyLeft', 'JustifyCenter', 'JustifyRight', 'JustifyBlock', '-',
      'Link', 'Unlink', 'Anchor', '-',
      'Table', 'SpecialChar', 'PageBreak', '-',
      'TextColor', 'BGColor'
    ]
  ]
}